// docs: https://github.com/altostra/type-validations#readme
import { arrayOf, objectOf } from "@altostra/type-validations";
import { string } from "@altostra/type-validations/lib/primitives";

export const isCompaniesCompanyIdSenderVerificationCreateIpAddressesResult = arrayOf(
  objectOf({
    address: string,
    rdns_status: string,
    dns_records: arrayOf(
      objectOf({
        type: string,
        hostname: string,
        value: string,
      })
    ),
  })
);
